import React, { FunctionComponent, useEffect, useState, ChangeEvent } from "react";
import { useSelector } from 'react-redux';
import StickyFilter from '../Module_Wounds/Filters/StickyFilters/StickyFilter';
import { ExpansionPanel, ExpansionPanelSummary, Box, makeStyles, ListItem, ExpansionPanelDetails, MenuItem, ButtonBase, TextField } from "@material-ui/core";
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import List from '@material-ui/core/List';
import Container from 'react-bootstrap/Container'
import { useTranslation } from 'react-i18next';

//VARIABLES
import variables from '../../assets/bootstrap/scss/_variables.scss';
import { isDefined } from "../../utils/utils";

// ICONS
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ClearIcon from '@material-ui/icons/Clear';
import moment from "moment";
import { Row, Col } from "react-bootstrap";
import DateCalendarField from "../../components/DateCalendar/DateCalendarField";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import DropDownF3M from "../../components/dropdown/dropDownF3M";
import Autocomplete from "@material-ui/lab/Autocomplete";

type OnChangeFnType = (instance: any) => void;
//type OnChangeDatesFnType = (dateFrom: any, dateTo: any) => void;
type OnClearFnType = (type: string) => void;

interface StickyFilterProps {
  containerButtonClearClasses?: string,
  OnChangeFrom: OnChangeFnType,
  OnChangeTo: OnChangeFnType,
  filterDateFrom: any,
  filterDateTo: any,
  OnClearFilter: OnClearFnType,
  establishments: any,
  onChangeEstab: OnChangeFnType,
  selectedEstablishments: any
}

const whiteColor = variables.white;
const primaryColor = variables.primary;
const secondaryColor = variables.secondary;

const useStyles = makeStyles((theme) => ({
  root: {

    '&.MuiCheckbox-root': {
      paddingLeft: 0,
    },
    '&.MuiList-root': {
      marginTop: 7,
      width: 80,
    },
    '&.MuiListItemIcon-root': {
      minWidth: 29,
      maxWidth: 30,
      display: "inline",
      textAlign: "center"
    },
    '&.MuiListItem-root': {
      paddingTop: 5,
      paddingBottom: 0,
      paddingLeft: 4,
      paddingRight: 4,
    },
    '&.MuiListItemText-root': {
      whiteSpace: "nowrap",
    },
    '&.MuiCheckbox-colorSecondary': {
      '&.Mui-checked': {
        color: "#4CB3BA",
      }
    },
    '&.MuiExpansionPanelDetails-root': {
      paddingBottom: 0,
    },
    '&.MuiChip-root': {
      display: 'flex',
      fontFamily: 'Roboto Condensed',
      flexWrap: 'nowrap',
      justifyContent: 'center',
      background: whiteColor,
      borderColor: primaryColor,
      color: primaryColor,
      border: "solid",
      borderWidth: 1,
      marginLeft: 8,
      marginRight: 8,
      fontSize: 12,
      fontWeight: 700,
      height: 22,
      '&:first-of-type': {
        //marginLeft: 12,
        [theme.breakpoints.down('md')]: {
          marginLeft: 0,
        },
      },

      '& > *': {
        margin: theme.spacing(0.5),
      },
      '& .MuiChip-label': {
        marginTop: 0,
        marginBottom: 0,
      },
      '& .MuiChip-deleteIcon': {
        marginTop: 0,
        marginBottom: 0,
        width: "14px",
      }
    },

    '& .MuiChip-label': {
      paddingRight: 0,

      "& .tag-chip": {
        maxWidth: 250,
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    },
  },
  deleteIcon: {
    color: primaryColor,

    "&:hover": {
      color: secondaryColor
    }
  },
  ListItem: {
    fontSize: 10,
    padding: 0,
  },
  h1: {
    fontSize: 90,
  },
  h2: {
    fontWeight: 300,
  },
  h4: {
    fontWeight: 500,
  },
  h5: {
    fontFamily: "Nunito",
    fontWeight: 700,
    letterSpacing: 1,
    fontSize: 16
  },
  h6: {
    fontSize: 17,
  },
  body1: {
    color: theme.palette.text.primary,
  },
  body2: {
    color: theme.palette.text.primary,
  },
  subtitle2: {
    fontSize: 12,
    color: theme.palette.text.primary,
  },
  dateLabels: {
    width: 70,
  },
  titleDoghnut: {
    height: 65,
  },
  nunitoBold14: {
    fontFamily: "Nunito",
    fontSize: 14,
    fontWeight: 700
  },
  expansionPanelSummary: {
    "& .MuiExpansionPanelSummary-content": {
      overflow: "hidden",
      [theme.breakpoints.down('sm')]: {
        display: "block",
      },
    },
  },
  autocompleteFilter:{
    '& .MuiChip-root': {
      display: 'flex',
      flexWrap: 'nowrap',
      justifyContent: 'center',
      background: whiteColor,
      borderColor: primaryColor,
      color: primaryColor,
      border: "solid",
      borderWidth: 1,
      marginLeft: 8,
      marginRight: 8,
      marginBottom: 3,
      marginTop: 3,
      fontSize: 12,
      fontWeight: 400,
      fontFamily: 'Roboto Condensed',
      height: 22,
      [theme.breakpoints.down('md')]: {
        marginLeft: 0,
      },
      '& > *': {
        margin: theme.spacing(0.5),
        marginRight: 2,
        marginLeft: 0
      },
      '& .MuiChip-label': {
        marginTop: 0,
        marginBottom: 0,
      },
      '& .MuiChip-deleteIcon': {
        marginTop: 0,
        marginBottom: 0,
        marginRight: 5,
        width: "14px",
      }
    },

    '& .MuiChip-label': {
      paddingRight: 2,

      "& .tag-chip":{
        maxWidth: 250,
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    },

  },
  listFiltersContainer:{
    [theme.breakpoints.down('md')]: {

    },
  }
}));

const StickyFilterPanelDashboard: FunctionComponent<StickyFilterProps> = (props) => {
  const classes = useStyles();

  const { t } = useTranslation();

  var listEstablishments = [{ rowKey: "all", description: t('WoundsType.all') }]
  var showEstab = false
  if (isDefined(props.establishments)) {
    listEstablishments = props.establishments;
    showEstab = (listEstablishments.length > 1)
  }

  var listSelected = [{ rowKey: "all", description: t('WoundsType.all') }]
  if (isDefined(props.selectedEstablishments)) {
    listSelected = props.selectedEstablishments;
  }
  var allProfissional = [{ rowKey: "all", name: t('WoundsType.all') }]
  //var healthProfissionalService = store.login.listOfUsersInstitution || []
  //const healthProfessionals1 = allProfissional.concat(healthProfissionalService)
  const [width, setWidth] = useState(window.innerWidth);
  // const handleDateChange = (name: string) => (date: string | number | void | moment.Moment | Date | (string | number)[] | moment.MomentInputObject | null) => {
  //   switch (name) {
  //     case "dateFrom":
  //       if (date != null) {
  //         if (store.wounds.FilterDateFrom !== date) {
  //           store.wounds.FilterDateFrom = date
  //           store.wounds.Refresh = moment(date).isValid()
  //           store.wounds.Page = 0
  //         }
  //       } else {
  //         if (store.wounds.FilterDateFrom != null) {
  //           store.wounds.FilterDateFrom = null
  //           store.wounds.Refresh = true
  //           store.wounds.Page = 0
  //         }
  //       }
  //       break;
  //     case "dateTo":
  //       if (date != null) {
  //         if (store.wounds.FilterDateTo !== date) {
  //           store.wounds.FilterDateTo = date
  //           store.wounds.Refresh = moment(date).isValid()
  //           store.wounds.Page = 0
  //         }
  //       } else {
  //         if (store.wounds.FilterDateTo != null) {
  //           store.wounds.FilterDateTo = null
  //           store.wounds.Refresh = true
  //           store.wounds.Page = 0
  //         }
  //       }
  //       break;
  //     default:
  //       break;
  //   }
  //   // if (store.wounds.Refresh) {
  //   //   onFilterChanged()
  //   // }
  //   /* else {
  //     this.props.setLoading(false)
  //   } */
  // };

  const [filtersExpanded, setFiltersExpanded] = useState(false);

  const onChangeExpanded = (e: ChangeEvent<{}>) => {
    setFiltersExpanded(!filtersExpanded)
  }


  const haveFilters = () => {
    let haveFilter = false
    if (isDefined(props.filterDateFrom)) {
      haveFilter = true
    } else if (isDefined(props.filterDateTo)) {
      haveFilter = true
    } else if (listSelected.length > 0) {
      haveFilter = true
    }
    return haveFilter
  }

  const handleDeleteEst = (name: string, index: number) => (e: ChangeEvent<{}>) => {
    if (name === 'Est') {
      var list = [...props.selectedEstablishments];

      list.splice(index, 1);

      props.onChangeEstab(list);
    }
  }

  const handleDelete = (name: string) => (e: ChangeEvent<{}>) => {
    switch (name) {
      case "FilterDateFromAndTo":
        props.OnClearFilter("Dates");
        break;
      case "FilterDateFrom":
        props.OnClearFilter("FromDate");
        break;
      case "FilterDateTo":
        props.OnClearFilter("ToDate");
        break;
      case "AllFilters":
        e.stopPropagation();
        props.OnClearFilter("ALL");
        break;
      default:
        break;
    }
  };

  const onChangeFromData = (instance: any) => {
    props.OnChangeFrom(instance);
  }

  const onChangeToData = (instance: any) => {
    props.OnChangeTo(instance);
  }

  const onChangeEst = (instance: any, value: any, reason: any) => {
    props.onChangeEstab(value);
  }

  const updateWindowDimensions = () => {
    setWidth(window.innerWidth)
  }

  const handleResize = () => setWidth(window.innerWidth)

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    updateWindowDimensions();
  }, [])

  return (
    <>
      <ExpansionPanel expanded={filtersExpanded} onChange={onChangeExpanded}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header">
          <div className={`my-auto pl-4 d-inline`}>
            <Typography display="inline" variant="subtitle1" className={`${classes.nunitoBold14} pr-4`}>{t('filters')}</Typography>
          </div>

          <div className={`pt-2 ml-auto my-auto float-right ${width >= 767 ? "d-none" : " d-block"} ${width > 767 && haveFilters() ? "pt-2" : ""}`}>
            <ButtonBase className="Button-Clear" onClick={handleDelete('AllFilters')}>{t('cleanFilters')}</ButtonBase>
          </div>

          <Box className={`mt-2 mr-lg-3 mt-md-0 mb-2 mb-md-0 list-filters-container flex-1 ${classes.listFiltersContainer}`} hidden={!haveFilters()}>
            <List disablePadding className="ml-4 ml-md-4 ml-lg-0 list-filters">
              <ListItem className={`${classes.ListItem}`}>
                {isDefined(props.filterDateFrom) && isDefined(props.filterDateTo) ?

                  <Chip className={`${classes.root}`}
                    //classes={`${classes.label}`}
                    onDelete={handleDelete('FilterDateFromAndTo')} deleteIcon={<ClearIcon className={`${classes.deleteIcon}`} />} label={
                      <div>
                        <div className={`${props.filterDateFrom == !null || props.filterDateFrom == !undefined && props.filterDateFrom !== "" ? "add-padding-right " : ""} `}>
                          {t('WoundsFilter.FromAb')}
                          <span>&nbsp;{moment(props.filterDateFrom).format("DD.MM.YYYY")}&nbsp;</span>
                          {t('WoundsFilter.ToAb').toLowerCase()}
                          <span className={`${props.filterDateTo == !null || props.filterDateTo == !undefined && props.filterDateTo !== "" ? "add-padding-left " : ""} `}>&nbsp;{moment(props.filterDateTo).format("DD.MM.YYYY")}&nbsp;</span>
                        </div>
                      </div>
                    } />

                  :

                  (isDefined(props.filterDateFrom) && !isDefined(props.filterDateTo) ?

                    <Chip className={`${classes.root}`} onDelete={handleDelete('FilterDateFrom')} deleteIcon={<ClearIcon className={`${classes.deleteIcon}`} />} label={
                      <div className={`${props.filterDateFrom == !null || props.filterDateFrom == !undefined && props.filterDateFrom !== "" ? "add-padding-right " : ""} `}>{t('WoundsFilter.FromAb')} <span> {moment(props.filterDateFrom).format("DD.MM.YYYY")} </span></div>
                    } />
                    :
                    (isDefined(props.filterDateTo) ? <Chip className={`${classes.root}`} onDelete={handleDelete('FilterDateTo')} deleteIcon={<ClearIcon className={`${classes.deleteIcon}`} />} label={<div className={`${props.filterDateTo == !null || props.filterDateTo == !undefined && props.filterDateTo !== "" ? "add-padding-left " : ""} `}>{t('WoundsFilter.ToAb')} <span>{moment(props.filterDateTo).format("DD.MM.YYYY")}</span></div>} /> :
                      <>  </>
                    ))}

              </ListItem>

              {isDefined(props.selectedEstablishments) && props.selectedEstablishments !== '' ?
                listSelected.map((item, index) => (
                  <ListItem className={`${classes.ListItem}`}>
                    <div>
                      <Chip className={`${classes.root}`} onDelete={handleDeleteEst('Est', index)} deleteIcon={<ClearIcon className={`${classes.deleteIcon}`} />} label={<div className="tag-chip"><span>{item.description}</span> </div>} />
                    </div>
                  </ListItem>
                ))
                : ''}



            </List>
          </Box>
          <div className={`order-2 ml-auto my-auto float-right pr-4 ${width < 767 ? "d-none" : " d-block"} `}>
            <ButtonBase className="Button-Clear" onClick={handleDelete('AllFilters')}>{t('cleanFilters')}</ButtonBase>
          </div>


        </ExpansionPanelSummary>
        <ExpansionPanelDetails
          className={`${classes.root}`}
        >
          <Container className="px-0">
            <Row>
              <MuiPickersUtilsProvider utils={DateFnsUtils}
              //locale={language === "PT" ? pt : enGB}
              >
                <Col xs={6} md={3} lg={2}>
                  <DateCalendarField
                    id='DateFrom1'
                    fullWidth={true}
                    class="fix-height-input-state ajust-margin-top"
                    margin="normal"
                    labelText={t('WoundsFilter.From')}
                    inputLabelProps={{ shrink: true }}
                    valueInput={
                      props.filterDateFrom
                    }
                    onChangeInput={
                      onChangeFromData
                    }
                    maxDate={
                      props.filterDateTo
                    }
                    invalidDateMessage={t('invalidDateFormat')}
                  />
                </Col>
                <Col xs={6} md={3} lg={2}>
                  <DateCalendarField
                    id='DateTo1'
                    fullWidth={true}
                    labelText={t('WoundsFilter.To')}
                    class="fix-height-input-state ajust-margin-top"
                    margin="normal"
                    valueInput={
                      props.filterDateTo
                    }
                    inputLabelProps={{ shrink: true }}
                    onChangeInput={onChangeToData}
                    minDate={
                      props.filterDateFrom
                    }
                    invalidDateMessage={t('invalidDateFormat')}
                  />
                </Col>
              </MuiPickersUtilsProvider>
              <Col xs={12} md={4} lg={3}
                hidden={!showEstab}
              >
                <Autocomplete
                  multiple
                  id="EstablishmentsFilter"
                  options={listEstablishments}
                  getOptionLabel={(option) => option.description}
                  className={`${classes.autocompleteFilter}`}
                  onChange={onChangeEst}
                  value={props.selectedEstablishments}
                  getOptionSelected={(option, value) => {
                    return option.description === value.description;
                  }}
                  renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                      <Chip
                        label={option.description}
                        {...getTagProps({ index })}
                        className={`${classes.root}`}
                        deleteIcon={<ClearIcon className={`${classes.deleteIcon}`} />}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t('Establishments')}
                      margin= 'normal'
                      placeholder={props.selectedEstablishments !== undefined && props.selectedEstablishments.length > 0 ? '' : t('AllEstablishments')}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              </Col>
            </Row>
          </Container>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </>
  )
}

export default StickyFilterPanelDashboard;
